import * as React from "react";

interface WheelSpinIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
}

export const WheelSpinIcon = ({ fill = "#6F76BD", width = 38, height = 39, ...props }: WheelSpinIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 38 39" fill="none" {...props}>
    <path
      fill={fill}
      d="M25.22 1.11a.295.295 0 0 1 .418 0l2.298 2.299v.001a5.318 5.318 0 1 0 7.523 7.521l2.297 2.298a.295.295 0 0 1 0 .417l-7.94 7.94a.295.295 0 0 1-.418 0L17.28 9.468a.295.295 0 0 1 0-.418l7.94-7.94ZM14.878 11.452a.295.295 0 0 1 .418 0L27.414 23.57a.295.295 0 0 1 0 .418L13.207 38.195a.295.295 0 0 1-.418 0L10.7 36.106a.309.309 0 0 1-.005-.424 5.32 5.32 0 0 0-7.527-7.495.28.28 0 0 1-.392-.005L.671 26.077a.296.296 0 0 1 0-.418l14.207-14.207Z"
    />
  </svg>
);
